import Logo from "../../../../../assets/images/LogoNew.svg";
import LanguagePicker from '../../../../../components/LanguagePicker/LanguagePicker';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';

const AskMoreMessage = ({ title = "Individual Plus", hideContainerStyle = false, remark, data, loading, onNext = () => { }, testId }) => {
    const { t } = useTranslation();
    const resolvedTestId = resolveAutomationTestId(testId, "individual-plus-ask-more");
    return (
        <div style={hideContainerStyle ? {} : {}} className={hideContainerStyle ? "" : 'form-content-container xl'} data-testid={resolvedTestId}>
            {
                hideContainerStyle ? <></> : <div className='form-content-header' data-testid={buildAutomationChildTestId(resolvedTestId, "header")}>
                    <img
                        src={Logo}
                        alt={t("fv-bank")}
                        className="logo logo-dark form-content-logo"
                        data-testid={buildAutomationChildTestId(resolvedTestId, "logo")}
                    />
                    <div className='' data-testid={buildAutomationChildTestId(resolvedTestId, "language-wrap")}><LanguagePicker testId={buildAutomationChildTestId(resolvedTestId, "language")} /></div>
                </div>
            }
            <div className={` ${hideContainerStyle ? "w-100" : "form-content-body"}`} data-testid={buildAutomationChildTestId(resolvedTestId, "body")}>

                {hideContainerStyle ? <></> : <div className='form-content-body-header' data-testid={buildAutomationChildTestId(resolvedTestId, "body-header")}>
                    <div className='heading' data-testid={buildAutomationChildTestId(resolvedTestId, "title")}>{t(title)}</div>
                </div>}

                <div className={` ${hideContainerStyle ? "d-flex flex-column justify-content-center align-items-center " : " form-content-body-content "}`} data-testid={buildAutomationChildTestId(resolvedTestId, "content")}>
                    <div style={{ fontSize: "30px", lineHeight: 2 }} data-testid={buildAutomationChildTestId(resolvedTestId, "greeting")}>
                        {t("Hi")} {data?.Business_Name ? `${data?.Business_Name}` : `${data?.firstName} ${data?.lastName}`},
                    </div>
                    <div className="mt-3" style={{ fontSize: "20px" }} data-testid={buildAutomationChildTestId(resolvedTestId, "message")}>
                        {t("To proceed with your application, we require additional information.")}
                    </div>
                    <div style={{ fontSize: "20px" }} data-testid={buildAutomationChildTestId(resolvedTestId, "instruction")}>
                        {t("Please ensure you fill out the details requested in the following step.")}
                    </div>
                    <div className=' w-100 mt-4' data-testid={buildAutomationChildTestId(resolvedTestId, "footer")}>
                        <ButtonGroupNew
                            testId={buildAutomationChildTestId(resolvedTestId, "navigation")}
                            primaryActionTestIdSuffix="continue"
                            onNextClick={() => onNext()}
                            step={2}
                            asLabel={false}
                            loading={loading}
                            hideBackButton
                        />
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AskMoreMessage
